import type React from 'react';
import type { ConnectivityStatus } from '../state/selectors.js';

export interface ConnectivityPillProps {
  status: ConnectivityStatus;
  count?: number;
  className?: string;
}

export function ConnectivityPill({ status, count, className }: ConnectivityPillProps): React.JSX.Element {
  const label = count !== undefined ? `${status} (${count})` : status;
  const classes = ['conn-pill', `conn-${status}`, className].filter(Boolean).join(' ');
  return <span className={classes}>{label}</span>;
}
